import React, { useState, useEffect } from "react";
import { Box, Stack, Grid, Button, TextField, Typography, Autocomplete } from "@mui/material";
import moment from "moment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
// import InputField from "./formFields/InputField";
import { v4 as uuidv4 } from "uuid";

import * as actionType from "../../trak/actions";
import { connect } from "react-redux";
import DataGridPremiumComp from "../../shared/components/DataGridPremiumComp";
import { Link } from "react-router-dom";
import QuickAdd from "../../shared/components/QuickAdd";

import { getPractices /*userFilterList*/ } from "../../admin/actions";

const EstimatesReport = (props) => {
  const {
    estimateReportList = [],
    practices,
    success,
    loading,
    actions,
    location,
    metaData
    /*userList*/
  } = props;

  const defaultValues = {
    from: moment().subtract(30, "days").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
    practiceId: location === "workspace" ? localStorage.getItem("practiceId") : null,
    created_by: "",
    patientSearch: "",
    medcaseStatus: ""
  };

  const [pageSize, setPageSize] = useState({
    pageSize: 100,
    page: 0
  });
  const [rows, setRows] = useState([]);
  const [values, setValues] = useState(defaultValues);

  useEffect(() => {
    if (estimateReportList) {
      const rows = estimateReportList.map((res, indx) => {
        return { ...res, id: indx };
      });
      setRows(rows);
    }
  }, [estimateReportList, success]);

  const handleRunReport = () => {
    // const localStoragePracticeId = localStorage.getItem("practiceId");
    const payload = {
      estimate_date_from: values.from,
      estimate_date_to: values.to,
      check: "Workspace",
      practiceId: values.practiceId ? values.practiceId : "",
      created_by: values.created_by ? values.created_by : "",
      patientSearch: values.patientSearch ? values.patientSearch : "",
      medcaseStatus: values.medcaseStatus ? values.medcaseStatus : ""
    };
    console.log("zhr payload", payload);
    actions.getEstimateReport(payload);
  };

  useEffect(() => {
    actions.getPractices();
    // const localStoragePracticeId = localStorage.getItem("practiceId");
    const payload = {
      estimate_date_from: values.from,
      estimate_date_to: values.to,
      check: "Workspace",
      practiceId: values.practiceId ? values.practiceId : "",
      created_by: values.created_by ? values.created_by : "",
      patientSearch: values.patientSearch ? values.patientSearch : "",
      medcaseStatus: values.medcaseStatus ? values.medcaseStatus : ""
    };

    console.log("zhr payload", payload);
    actions.getEstimateReport(payload);
  }, []);

  useEffect(() => {
    actions.getMetaData();
  }, []);

  const handleAutoCompleteChange = (e, name, value) => {
    console.log(name, value);
    if (value) {
      setValues({
        ...values,
        [name]: value.value
      });
    } else {
      setValues({
        ...values,
        [name]: null
      });
    }
  };

  const handleSearchClick = (e, searchText) => {
    if (searchText) {
      // const localStoragePracticeId = localStorage.getItem("practiceId");
      const payload = {
        estimate_date_from: values.from,
        estimate_date_to: values.to,
        check: "Workspace",
        practiceId: values.practiceId ? values.practiceId : "",
        created_by: values.created_by ? values.created_by : "",
        patientSearch: searchText,
        medcaseStatus: values.medcaseStatus ? values.medcaseStatus : ""
      };
      setValues({
        ...values,
        patientSearch: searchText
      });
      //console.log("zhr payload", payload);
      actions.getEstimateReport(payload);
      return actions.estimateReportResetMessage();
    }

    // actions.resetFinancialEstimateList();
  };

  const clearSearchClick = () => {
    // values.patientNameOrId = "";
    // setValues({ ...values });
  };

  const columns = [
    {
      field: "patientName",
      headerName: "PATIEN NAME & PERSON #",
      flex: 1,
      editable: false,
      renderCell: ({ row }) => {
        const url = `/patients/${row?.personId}/personal`;
        return (
          <Link
            style={{ textDecoration: "none" }}
            target="_blank"
            to={url}
            onClick={(event) => {
              event.preventDefault();
              window.open(url, "_blank");
              // actions.getPersonalList({ practiceId: row?.practice_id, valuesForPatient });
              // localStorage.setItem("practiceId", row?.practice_id);
            }}>
            <Button
              color="primary"
              variant="text"
              className="word-wrap"
              onClick={() => {
                // actions.getPersonalList({ practiceId: row?.practice_id, valuesForPatient });
                // localStorage.setItem("practiceId", row?.practice_id);
              }}>
              <div style={{ flexFlow: "row" }}>
                {/* <Typography style={{ fontSize: "12px" }}>{`${firstName} ${lastName}`}</Typography> */}
                <Typography style={{ fontSize: "12px" }}>{`${
                  row.patientName ? row.patientName : ""
                }`}</Typography>
                <Typography style={{ fontSize: "12px" }}>{`${
                  row.personNumber ? row.personNumber : ""
                }`}</Typography>
              </div>
            </Button>
          </Link>
        );
      }
    },
    {
      field: "partnerName",
      headerName: "PARTNER NAME & PERSON #",
      flex: 1,
      editable: false,
      renderCell: ({ row }) => {
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography>{row?.partnerName || ""}</Typography>
            <Typography>{row?.partnerNumber || ""}</Typography>
          </div>
        );
      }
    },
    {
      field: "estimateId",
      headerName: "ESTIMATE ID",
      flex: 1,
      editable: false,
      renderCell: ({ row }) => {
        let estimateNumber = row.estimateId.split("-");
        return (
          <Link
            variant="contained"
            target="_blank"
            to={`/workspace/financial-estimates/${row.personId}`}>
            <Button
              color="primary"
              variant="text"
              onClick={() => {
                localStorage.setItem("patientName", row.patientName);
                // actions.resetEstimateViewList();
              }}
              className="word-wrap">
              {estimateNumber[1] ? estimateNumber[1] : "--"}
            </Button>
          </Link>
        );
      }
    },
    {
      field: "practiceName",
      headerName: "PRACTICE SHORT NAME",
      flex: 1,
      editable: false
    },
    {
      field: "primaryMdName",
      headerName: "PRIMARY MD",
      flex: 1,
      editable: false
    },
    {
      field: "treatmentPlan",
      headerName: "TREATMENT PLAN",
      flex: 1,
      editable: false,
      renderCell: ({ row }) =>
        row?.treatmentPlanCustomName != null ? row?.treatmentPlanCustomName : row?.treatmentPlan
    },
    {
      field: "creationDate",
      headerName: "ESTIMATE CREATED DATE",
      flex: 1,
      editable: false
    },
    {
      field: "createdBy",
      headerName: "ESTIMATE CREATED BY",
      flex: 1,
      editable: false
    },
    {
      field: "publishedDate",
      headerName: "ESTIMATE PUBLISHED Date",
      flex: 1,
      editable: false
    },
    {
      field: "publishedBy",
      headerName: "ESTIMATE PUBLISHED BY",
      flex: 1,
      editable: false
    },
    {
      field: "isRegistered",
      headerName: "REGISTERED FOR PORTAL (Y OR N)",
      flex: 1,
      editable: false
    },
    {
      field: "lastLoginDate",
      headerName: "LAST LOGIN DATE",
      flex: 1,
      editable: false
    },
    {
      field: "medcaseId",
      headerName: "MEDCASE ID",
      width: 60,
      editable: false,
      renderCell: ({ row }) => {
        return (
          <div style={{ display: "flex", flexFlow: "row" }}>
            {location === "track" ? (
              <Link
                to={`/trak/caselookup/caselist/${row.medcaseId}/status`}
                target="_blank"
                style={{
                  textDecoration: "none",
                  color: "#1BA3AD",
                  fontFamily: "Rubik"
                }}>
                {row?.medcaseId}
              </Link>
            ) : (
              <span>{row?.medcaseId ? row.medcaseId : "--"}</span>
            )}
          </div>
        );
      }
    },
    {
      field: "medcaseStatus",
      headerName: "MEDCASE STATUS",
      flex: 1,
      editable: false
    },
    {
      field: "contractStatus",
      headerName: "CONTACT STATUS",
      flex: 1,
      editable: false
    },
    {
      field: "paymentStatus",
      headerName: "PAYMENT STATUS",
      flex: 1,
      editable: false
    }
  ];

  return (
    <>
      <Stack direction="row" className="pad-5 m-t-8"></Stack>
      <Box className="m-8">
        <>
          <Box className="pad-5" sx={{ width: "100%" }}>
            <Box>
              <QuickAdd
                text={1}
                search={7}
                handleSearchClick={handleSearchClick}
                clearSearchClick={clearSearchClick}
              />
            </Box>
          </Box>
          <Box className="pad-5" sx={{ width: "68%" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={3}>
                    <Typography>Practice*</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Autocomplete
                      disablePortal
                      required
                      name="practiceId"
                      value={
                        practices?.find((item) => item?.practiceId === values?.practiceId)
                          ? `${
                              practices?.find((item) => item?.practiceId === values?.practiceId)
                                ?.name
                            } - ${values?.practiceId}`
                          : ""
                      }
                      options={
                        practices?.length > 0
                          ? practices?.map((item, index) => ({
                              id: index,
                              label: `${item.name} - ${item.practiceId}`,
                              name: item.name,
                              value: item.practiceId
                            }))
                          : []
                      }
                      onChange={(e, value) => handleAutoCompleteChange(e, "practiceId", value)}
                      renderInput={(params) => <TextField {...params} fullWidth />}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={3}>
                    <Typography>Created By*</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <TextField
                      fullWidth
                      required
                      name="created_by"
                      label="Created By"
                      value={values.created_by || ""}
                      onChange={(e) => {
                        setValues((prev) => ({
                          ...prev,
                          created_by: e.target.value
                        }));
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box className="pad-5" sx={{ width: "68%" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={3}>
                    <Typography>Created Date From*</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        openTo="day"
                        views={["day"]}
                        disableFuture
                        value={values.from}
                        onChange={(newValue) => {
                          const formatted = moment(newValue).format("YYYY-MM-DD");
                          setValues({ ...values, from: formatted });
                        }}
                        renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={3}>
                    <Typography>Created Date To*</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        openTo="day"
                        views={["day"]}
                        disableFuture
                        value={values.to}
                        onChange={(newValue) => {
                          const format2 = "YYYY-MM-DD";
                          const formatted = moment(newValue).format(format2);
                          setValues({ ...values, to: formatted });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            className="patient-dropdown"
                            fullWidth
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              {/* <Grid item xs={6}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs={3}>
                  <Typography>Created By*</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Autocomplete
                    options={userOptions}
                    value={selectedUser}
                    inputValue={findUserName}
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === "input") {
                        setFindUserName(newInputValue);
                      }
                    }}
                    onChange={(event, newValue) => {
                      setSelectedUser(newValue);
                      handleAutoCompleteChange(event, "created_by", newValue);
                    }}
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    renderOption={(props, option) => <li {...props}>{option.label}</li>}
                  />
                </Grid>
              </Grid>
            </Grid> */}
            </Grid>
          </Box>
          <Box className="pad-5" sx={{ width: "68%" }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={3}>
                    <Typography>Medcase Status</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Autocomplete
                      disablePortal
                      required
                      name="medcaseStatus"
                      value={
                        metaData?.medcaseStatus?.find((item) => item === values?.medcaseStatus)
                          ? `${metaData?.medcaseStatus?.find(
                              (item) => item === values?.medcaseStatus
                            )}`
                          : ""
                      }
                      options={
                        metaData?.medcaseStatus?.length > 0
                          ? metaData?.medcaseStatus?.map((item, index) => ({
                              id: index,
                              label: `${item}`,
                              name: item,
                              value: item
                            }))
                          : []
                      }
                      onChange={(e, value) => {
                        if (value) {
                          handleAutoCompleteChange(e, "medcaseStatus", value);
                        } else {
                          handleAutoCompleteChange(e, "medcaseStatus", { value: "" }); // or null, depending on what you want
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Medcase Status..."
                          sx={{ paddingTop: "7px" }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <Box className="pad-5" sx={{ width: "68%" }}>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Button variant="contained" className="btn-usf" onClick={handleRunReport}>
                  Run Report
                </Button>
              </Grid>
            </Grid>
          </Box>
        </>
        <Box className="grid-style" sx={{ height: "660px" }}>
          <DataGridPremiumComp
            rows={rows}
            rowCount={rows?.length}
            columns={columns}
            loading={loading}
            pageSizeOptions={[10, 20, 50, 100]}
            pageSize={pageSize.pageSize}
            paginationModel={pageSize}
            onPaginationModelChange={(newPageSize) => setPageSize(newPageSize)}
            pagination
            localeText={"Export Button"}
            //components={<CustomToolbar />}
            isExport={true}
            headerText={`Outcomes From: ${values.from} - To ${values.to} `}
            disableRowSelectionOnClick={true}
            getRowId={() => uuidv4()}
          />
        </Box>
      </Box>
    </>
  );
};

const mapStateToProps = ({
  caseUpdateReducer,
  estimateReportReducer,
  practices /*userReducer*/
}) => {
  return {
    /*userList: userReducer.userList,*/
    estimateReportList: estimateReportReducer.estimateReportList,
    loading: estimateReportReducer.loading,
    error: estimateReportReducer.error,
    success: estimateReportReducer.success,
    practices: practices.practices,
    metaData: caseUpdateReducer.metaData
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: {
    /*userFilterList: (payload) => {
      dispatch(userFilterList(payload));
    },*/
    getMetaData: () => {
      dispatch(actionType.getMetaData());
    },
    getEstimateReport: (payload) => {
      dispatch(actionType.getEstimateReport(payload));
    },
    estimateReportResetMessage: () => {
      dispatch(actionType.estimateReportResetMessage());
    },
    getPractices: () => {
      dispatch(getPractices());
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(EstimatesReport);
